import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";

import Button from "../../components/Button";
import VerifyModal from "../../components/VerifyModal";

//assets
import walletIcon from "../../assets/wallet_wc.svg";
import ProcessingModal from "../../components/ProcessingModal";
import { HomePageBgTop } from "../../components/Background/HomePage_Bg";

const ProgressComp = ({ statusCount }: { statusCount: number }) => {
  // let varients = {
  //   start: {
  //     transition: {
  //       duration: 1,
  //       ease: "easeInOut",
  //     },
  //     d: "M33.3089 15.1758C30.2985 15.1758 27.9098 17.601 26.5898 20.3066C24.3166 24.9659 19.5332 28.1758 14 28.1758C6.26801 28.1758 0 21.9078 0 14.1758C0 6.44379 6.26801 0.175781 14 0.175781C19.3071 0.175781 23.9245 3.1288 26.2987 7.48135C27.6651 9.98633 29.9775 12.1758 32.8309 12.1758H118.502C119.33 12.1758 120.002 12.8474 120.002 13.6758V13.6758C120.002 14.5042 119.33 15.1758 118.502 15.1758H33.3089Z",
  //   },
  //   middle: {
  //     transition: {
  //       duration: 1,
  //       ease: "easeInOut",
  //     },
  //     d: "M14 28.1758C19.5332 28.1758 24.3166 24.9659 26.5898 20.3066C27.9098 17.601 30.2985 15.1758 33.3089 15.1758H239.691C242.702 15.1758 245.09 17.601 246.41 20.3066C248.683 24.9659 253.467 28.1758 259 28.1758C264.533 28.1758 269.317 24.9659 271.59 20.3066C272.91 17.601 275.298 15.1758 278.309 15.1758H288.502C289.33 15.1758 290.002 14.5042 290.002 13.6758V13.6758C290.002 12.8474 289.33 12.1758 288.502 12.1758H277.831C274.977 12.1758 272.665 9.98633 271.299 7.48135C268.925 3.1288 264.307 0.175781 259 0.175781C253.693 0.175781 249.075 3.1288 246.701 7.48135C245.335 9.98633 243.023 12.1758 240.169 12.1758H32.8309C29.9775 12.1758 27.6651 9.98633 26.2987 7.48135C23.9245 3.1288 19.3071 0.175781 14 0.175781C6.26801 0.175781 0 6.44379 0 14.1758C0 21.9078 6.26801 28.1758 14 28.1758Z",
  //   },
  //   final: {
  //     transition: {
  //       duration: 1,
  //       ease: "easeInOut",
  //     },
  //     d: "M33.3968 15.1758C30.4139 15.1758 28.0382 17.5587 26.7092 20.2292C24.417 24.8352 19.6621 28 14.168 28C6.43598 28 0.167969 21.732 0.167969 14C0.167969 6.26801 6.43598 0 14.168 0C19.5155 0 24.1628 2.99821 26.5206 7.40532C27.8796 9.94569 30.2058 12.1758 33.0869 12.1758H240.081C242.962 12.1758 245.288 9.94568 246.647 7.40532C249.005 2.9982 253.652 0 259 0C264.348 0 268.995 2.99821 271.353 7.40533C272.712 9.94569 275.038 12.1758 277.919 12.1758H485.081C487.962 12.1758 490.288 9.94569 491.647 7.40533C494.005 2.99821 498.652 0 504 0C511.732 0 518 6.26801 518 14C518 21.732 511.732 28 504 28C498.506 28 493.751 24.8352 491.459 20.2292C490.13 17.5587 487.754 15.1758 484.771 15.1758H278.229C275.246 15.1758 272.87 17.5587 271.541 20.2292C269.249 24.8352 264.494 28 259 28C253.506 28 248.751 24.8352 246.459 20.2292C245.13 17.5587 242.754 15.1758 239.771 15.1758H33.3968Z",
  //   },
  // };

  return (
    <div
      css={css`
        display: flex;
        margin-left: auto;
        justify-content: flex-end;
      `}
    >
      {/* <HomePageBgTop /> */}
      <ProcessingModal processingMessage={"Loading"} />
    </div>
    // <span
    //   css={css`
    //     display: flex;
    //     position: relative;
    //     align-items: center;
    //     width: 518px;
    //   `}
    // >
    //   <span
    //     css={css`
    //       display: flex;
    //       position: absolute;
    //       justify-content: space-between;
    //       width: 100%;
    //       margin-bottom: 60px;
    //     `}
    //   >
    //     {["Intializing", "Minting", "Finish"].map((ele) => {
    //       return (
    //         <p
    //           css={css`
    //             font-weight: 700;
    //             font-size: 14px;
    //             margin: 0;
    //             margin-right: ${ele === "Minting" ? "20px" : "0"};
    //           `}
    //         >
    //           {ele}
    //         </p>
    //       );
    //     })}
    //   </span>
    //   <span
    //     css={css`
    //       position: absolute;
    //       display: flex;
    //       width: 100%;
    //       justify-content: space-between;
    //       align-items: center;
    //       top: 0;
    //       bottom: 0;
    //       padding: 0 10px;
    //       font-weight: 700;
    //       font-size: 14px;
    //     `}
    //   >
    //     {[1, 2, 3].map((item, index) => (
    //       <p
    //         css={css`
    //           color: ${index === statusCount ? "#ffffff" : "#000"};
    //         `}
    //       >
    //         {item}
    //       </p>
    //     ))}
    //   </span>
    //   <svg
    //     width="519"
    //     height="29"
    //     viewBox="0 0 519 29"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       fill-rule="evenodd"
    //       clip-rule="evenodd"
    //       d="M33.3968 15.1758C30.4139 15.1758 28.0382 17.5587 26.7092 20.2292C24.417 24.8352 19.6621 28 14.168 28C6.43598 28 0.167969 21.732 0.167969 14C0.167969 6.26801 6.43598 0 14.168 0C19.5155 0 24.1628 2.99821 26.5206 7.40532C27.8796 9.94569 30.2058 12.1758 33.0869 12.1758H240.081C242.962 12.1758 245.288 9.94568 246.647 7.40532C249.005 2.9982 253.652 0 259 0C264.348 0 268.995 2.99821 271.353 7.40533C272.712 9.94569 275.038 12.1758 277.919 12.1758H485.081C487.962 12.1758 490.288 9.94569 491.647 7.40533C494.005 2.99821 498.652 0 504 0C511.732 0 518 6.26801 518 14C518 21.732 511.732 28 504 28C498.506 28 493.751 24.8352 491.459 20.2292C490.13 17.5587 487.754 15.1758 484.771 15.1758H278.229C275.246 15.1758 272.87 17.5587 271.541 20.2292C269.249 24.8352 264.494 28 259 28C253.506 28 248.751 24.8352 246.459 20.2292C245.13 17.5587 242.754 15.1758 239.771 15.1758H33.3968Z"
    //       fill="#CCC4B3"
    //     />
    //     {/* <path
    //       fill-rule="evenodd"
    //       clip-rule="evenodd"
    //       d="M14 28.1758C19.5332 28.1758 24.3166 24.9659 26.5898 20.3066C27.9098 17.601 30.2985 15.1758 33.3089 15.1758H239.691C242.702 15.1758 245.09 17.601 246.41 20.3066C248.683 24.9659 253.467 28.1758 259 28.1758C264.533 28.1758 269.317 24.9659 271.59 20.3066C272.91 17.601 275.298 15.1758 278.309 15.1758H288.502C289.33 15.1758 290.002 14.5042 290.002 13.6758V13.6758C290.002 12.8474 289.33 12.1758 288.502 12.1758H277.831C274.977 12.1758 272.665 9.98633 271.299 7.48135C268.925 3.1288 264.307 0.175781 259 0.175781C253.693 0.175781 249.075 3.1288 246.701 7.48135C245.335 9.98633 243.023 12.1758 240.169 12.1758H32.8309C29.9775 12.1758 27.6651 9.98633 26.2987 7.48135C23.9245 3.1288 19.3071 0.175781 14 0.175781C6.26801 0.175781 0 6.44379 0 14.1758C0 21.9078 6.26801 28.1758 14 28.1758Z"
    //       fill="#191414"
    //     /> */}
    //     {/* <path
    //     fill-rule="evenodd"
    //     clip-rule="evenodd"
    //     d="M33.3089 15.1758C30.2985 15.1758 27.9098 17.601 26.5898 20.3066C24.3166 24.9659 19.5332 28.1758 14 28.1758C6.26801 28.1758 0 21.9078 0 14.1758C0 6.44379 6.26801 0.175781 14 0.175781C19.3071 0.175781 23.9245 3.1288 26.2987 7.48135C27.6651 9.98633 29.9775 12.1758 32.8309 12.1758H118.502C119.33 12.1758 120.002 12.8474 120.002 13.6758V13.6758C120.002 14.5042 119.33 15.1758 118.502 15.1758H33.3089Z"
    //     fill="#191414"
    //   /> */}
    //     <motion.path
    //       fill-rule="evenodd"
    //       clip-rule="evenodd"
    //       d="M33.3089 15.1758C30.2985 15.1758 27.9098 17.601 26.5898 20.3066C24.3166 24.9659 19.5332 28.1758 14 28.1758C6.26801 28.1758 0 21.9078 0 14.1758C0 6.44379 6.26801 0.175781 14 0.175781C19.3071 0.175781 23.9245 3.1288 26.2987 7.48135C27.6651 9.98633 29.9775 12.1758 32.8309 12.1758H118.502C119.33 12.1758 120.002 12.8474 120.002 13.6758V13.6758C120.002 14.5042 119.33 15.1758 118.502 15.1758H33.3089Z"
    //       fill="#191414"
    //       variants={varients}
    //       animate={Object.keys(varients)[statusCount - 1]}
    //     />
    //   </svg>
    // </span>
  );
};

function TestPage() {
  return (
    <div>
      <VerifyModal />
    </div>
  );
}

export default TestPage;
